"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findURLs = exports.includesURL = void 0;
/**
 * Returns whether a string contains a URL inside it.
 *
 * This helper was built originally to prevent URLs being added on notification messages while allowing email addresses to go through.
 *
 * Keep in mind that while it matches number based domains that look like IP addresses it should not be used as such.
 */
function includesURL(str) {
    return findURLs(str).length > 0;
}
exports.includesURL = includesURL;
/**
 * Returns potential URLs inside of a string.
 *
 * This helper was built originally to prevent URLs being added on notification messages while allowing email addresses to go through.
 *
 * Keep in mind that while it matches number based domains that look like IP addresses it should not be used as such.
 */
function findURLs(str) {
    var _a, _b;
    const includeRegex = /[\w\-._~:/?#[\]@!$&'()*+,;%=]{1,256}\.\b([\w\-._~:/?#[\]@!$&'()*+,;%=]*)/g;
    const excludeRegex = /.+@.+/;
    return ((_b = (_a = str
        .match(includeRegex)) === null || _a === void 0 ? void 0 : _a.filter((match) => excludeRegex.test(match) === false)) !== null && _b !== void 0 ? _b : []);
}
exports.findURLs = findURLs;
